import getBlock from './block';
import customizationConstants from '../../customization/constants';

const { CUSTOM_COLOR_SCHEME_PREFIX } = customizationConstants;

const getCustomSchemeOptions = (palette) => {
  const { schemes } = palette;

  if (!schemes) return [];

  return Object.entries(schemes)
    .filter(([schemeId]) => schemeId.startsWith(CUSTOM_COLOR_SCHEME_PREFIX))
    .map(([value, { label }]) => ({ value, label }));
};

const getBlockSettings = (rootState, blockId, palette) => {
  const block = getBlock(rootState, blockId);

  if (!block || !block.availableSettings) {
    return null;
  }

  const { availableSettings } = block;

  if (!palette || !Array.isArray(availableSettings.displayOptions)) {
    return availableSettings;
  }

  const customSchemeOptions = getCustomSchemeOptions(palette);

  if (!customSchemeOptions.length) {
    return availableSettings;
  }

  return {
    ...availableSettings,
    displayOptions: availableSettings.displayOptions.map((option) => {
      if (option.type !== 'surface') return option;

      return {
        ...option,
        options: [...(option.options || []), ...customSchemeOptions],
      };
    }),
  };
};

export default getBlockSettings;
